import * as yup from 'yup'

const schema = yup.object().shape(
  {
    tipoMonta: yup.string().required('Selecione um tipo de monta.'),
    idFazenda: yup.string().required('Fazenda é obrigatório.'),

    // Lote: obrigatório apenas para tipo "monta"
    idLote: yup
      .string()
      .nullable()
      .transform((value) => (value === '' ? null : value))
      .when('tipoMonta', {
        is: 'monta',
        then: (schema) => schema.required('Lote é obrigatório para monta.'),
        otherwise: (schema) => schema.notRequired().nullable()
      }),

    // Vaca: obrigatório para "montaControlada" e "inseminacaoArtificial"
    idVaca: yup
      .string()
      .nullable()
      .transform((value) => (value === '' ? null : value))
      .when('tipoMonta', {
        is: (value: string) => value === 'montaControlada' || value === 'inseminacaoArtificial',
        then: (schema) => schema.required('Vaca é obrigatório.'),
        otherwise: (schema) => schema.notRequired().nullable()
      }),

    // Touro: opcional para todos
    idTouro: yup.string().notRequired().nullable(),

    // Data do cio: obrigatório para "montaControlada" e "inseminacaoArtificial"
    dataCio: yup
      .string()
      .nullable()
      .transform((value) => (value === '' ? null : value))
      .when('tipoMonta', {
        is: (value: string) => value === 'montaControlada' || value === 'inseminacaoArtificial',
        then: (schema) => schema.required('Data do cio é obrigatória.'),
        otherwise: (schema) => schema.notRequired().nullable()
      }),

    // Inseminador: obrigatório apenas para "inseminacaoArtificial"
    inseminador: yup
      .string()
      .nullable()
      .transform((value) => (value === '' ? null : value))
      .when('tipoMonta', {
        is: 'inseminacaoArtificial',
        then: (schema) => schema.required('Inseminador é obrigatório.'),
        otherwise: (schema) => schema.notRequired().nullable()
      }),

    dataInicio: yup.string().when('tipoMonta', {
      is: (val: string) => val !== 'inseminacaoArtificial',
      then: yup.string().required('Data início é obrigatória'),
      otherwise: yup.string().nullable()
    }),

    dataFim: yup.string().when('tipoMonta', {
      is: (val: string) => val !== 'inseminacaoArtificial',
      then: yup.string().required('Data final é obrigatória'),
      otherwise: yup.string().nullable()
    })
  },
  [
    // Lista de dependências circulares para when()
    ['tipoMonta', 'idLote'],
    ['tipoMonta', 'idVaca'],
    ['tipoMonta', 'dataCio'],
    ['tipoMonta', 'inseminador']
  ]
)

export default schema
